import { DEFAULT_MORNING_BOOT_STATE, type MorningBootState } from './types';

export function loadMorningBootState(storageKey: string): MorningBootState {
  if (typeof localStorage === 'undefined') return { ...DEFAULT_MORNING_BOOT_STATE };
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return { ...DEFAULT_MORNING_BOOT_STATE };
    const parsed = JSON.parse(raw) as MorningBootState;
    return {
      backlog: parsed.backlog ?? [],
      sessions: parsed.sessions ?? [],
      settings: {
        mode: parsed.settings?.mode ?? 'basic',
        preferredTime: parsed.settings?.preferredTime ?? 'morning',
      },
    };
  } catch {
    return { ...DEFAULT_MORNING_BOOT_STATE };
  }
}

export function saveMorningBootState(storageKey: string, state: MorningBootState): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(storageKey, JSON.stringify(state));
}
